export const simpleId = () => Math.random().toString(36).substr(2, 9)
